import type { ComponentType } from "react";

import * as COMPONENTS from "~components/modules";
import * as INTEGRITY from "~components/modules/integrity";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export const LINEUP_COMPONENTS: {
    // A few components (i.e. Carousel, etc.) don't align with VariationComponent we need to build a type for the component registry
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: ComponentType<any>;
} = COMPONENTS;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IntegrityCheckFn<T = any> = (args: T) => IntegrityStatus;

export const LINEUP_INTEGRITY_CHECKS: {
    [key: string]: IntegrityCheckFn;
} = INTEGRITY;

export const COMPONENTS_WITH_PAGINATION = [
    "StoryListPagination",
    "StoryListAuthorPage",
    "LineupContentArchive",
];
